Wee.fn.make('quoteModal', {
	init: function () {
		var scope = this;

		this.$modal = $('ref:modalQuote');

		$.events.on({
			'ref:body': {
				keyup: function(e) {
					if (e.keyCode == 27) {
						scope.close();
					}
				},
				click: function(e) {
					if (e.target === scope.$modal[0]) {
						scope.close();
					}
				},
			},

			'ref:modalQuoteClose': {
				click: function (e) {
					scope.close();
				}
			},

			'ref:quoteCard': {
				click: function(e, el) {
					var $el = $(el);

					scope.$modal.show();

					scope.initModalSwiper(1, 1);

					scope.swiper.slideTo($el.data('id'));
				}
			}
		});

	},
	initModalSwiper: function (slidesPerColumn, slidesPerView) {
		this.swiper = new Swiper('.js-modal-swiper', {
			slidesPerColumn: slidesPerColumn,
			slidesPerView: slidesPerView,
			slidesPerColumnFill: 'row',
			spaceBetween: 20,
			speed: 0,
			nextButton: '.js-modal-swiper-button-next',
			prevButton: '.js-modal-swiper-button-prev',
			pagination: '.swiper-pagination',
			paginationClickable: true,
		});
	},

	show: function(e) {
		this.$modal.show();
		$($._body).toggleClass('-is-disabled');
		e.preventDefault();
	},

	close: function() {
		this.$modal.hide();
		$($._body).removeClass('-is-disabled');
	},
});